import { DemoScript } from './demo-script.types';

/**
 * "Create a sale & send the e-Fatura" — start on the dashboard, navigate to
 * Satışlar from the sidebar, start a sale for a registered customer, pick the
 * customer + product (price/KDV auto-fill but are editable), set quantity, and
 * save. Saving opens the new sale's detail page, where the cursor sends the
 * e-Fatura: clicks "e-Belge Gönder", walks through BOTH invoice-type options,
 * selects Ticari Fatura, and the built-in "sending to GİB" overlay plays.
 *
 * Customer/product selection and the send confirmation go through
 * page-registered actions (the autocompletes and the shared modal's accept
 * button can't be expressed as plain control writes); date, time and currency
 * default to valid values on load.
 */
export const invoiceScript: DemoScript = async (ctx) => {
  await ctx.goto('/dashboard?mockData=true');
  await ctx.wait(1300);

  ctx.say('Satış faturası kesmek için sol menüden Satışlar’a tıklıyoruz');
  await ctx.click('nav-sales');
  await ctx.wait(1000);

  ctx.say('“Kayıtlı Müşteriye Satış Gir” diyerek yeni satış faturası başlatıyoruz');
  await ctx.click('new-sale');
  await ctx.wait(1000);

  ctx.say('Faturayı keseceğimiz müşteriyi listeden seçiyoruz');
  await ctx.action('inv-customer', 'selectCustomer');
  await ctx.wait(700);

  ctx.say('Satılan ürünü seçiyoruz — birim fiyat ve KDV otomatik dolar');
  await ctx.action('inv-line-product-0', 'selectLineProduct', 0, 0);
  await ctx.wait(800);

  ctx.say('İstersek birim fiyatı elle değiştirebiliriz');
  await ctx.set('inv-line-price-0', 'lines.0.unitPrice', 2500);
  await ctx.wait(500);

  ctx.say('KDV oranını da buradan seçebiliriz (varsayılan %20)');
  await ctx.set('inv-line-vat-0', 'lines.0.vatRate', 20);
  await ctx.wait(500);

  ctx.say('Satılan ürün miktarını giriyoruz');
  await ctx.set('inv-line-qty-0', 'lines.0.quantity', 2);
  await ctx.wait(500);

  ctx.say('Faturaya ikinci bir ürün eklemek için “Satır Ekle”ye tıklıyoruz');
  await ctx.click('inv-add-line');
  await ctx.wait(800);

  ctx.say('İkinci ürünü seçiyoruz');
  await ctx.action('inv-line-product-1', 'selectLineProduct', 1, 1);
  await ctx.wait(800);

  ctx.say('İkinci satırın miktarını giriyoruz');
  await ctx.set('inv-line-qty-1', 'lines.1.quantity', 3);
  await ctx.wait(500);

  ctx.say('Faturayı kaydediyoruz; satışın detay sayfası açılır');
  await ctx.action('inv-save', 'saveInvoice');
  await ctx.wait(1600);

  ctx.say('Faturayı GİB‘e göndermek için “e-Belge Gönder”e tıklıyoruz');
  await ctx.click('inv-send');
  await ctx.wait(800);

  // Walk through both invoice-type options, explaining each, then pick Ticari.
  ctx.say('Temel Fatura: belge alıcıya otomatik iletilir, onay/red gerekmez');
  await ctx.click('inv-scenario-temel');
  await ctx.wait(800);

  ctx.say('Ticari Fatura: alıcı kabul veya reddedebilir — bunu seçiyoruz');
  await ctx.click('inv-scenario');
  await ctx.wait(800);

  // Click the modal's real "Gönder" button (no caption — the app's sending
  // overlay carries the moment).
  await ctx.click('inv-send-confirm');
  await ctx.wait(4200); // let the "sending to GİB" overlay play through

  await ctx.wait(1200);
};
